/**
 * Houseplant v2 — Cart featured showcase
 *
 * The toggle behind snippets/hp-cart-featured.liquid.
 *
 * ── DELEGATED, NOT BOUND, and that is the whole fix ────────────────────────
 * The first version bound a click listener to each toggle on DOMContentLoaded
 * and re-bound on `cartUpdate`. It never fired, because neither moment is when
 * the drawer's markup appears: `MiniCart` in cart-drawer.js fetches its own
 * content on first intersection, replaces #mini-cart's innerHTML, and announces
 * it with `cartdrawer:opened` — an event the binder was not listening for. So
 * the toggle in the live drawer was always an unbound button and clicking it did
 * nothing.
 *
 * Chasing that with one more event name would have been the wrong repair: the
 * drawer's innerHTML is replaced on every cart update too, so anything holding a
 * node reference is one render away from being detached again. A single
 * document-level listener has no node to lose and needs no init.
 *
 * ── The panel's visibility is CSS, not JS ──────────────────────────────────
 * This script only flips `aria-expanded`; the stylesheet keys the panel off it.
 * That removes the second half of the old bug — a hidden state applied by an
 * init pass that also had to run at the right moment.
 *
 * No progressive-enhancement cost: the drawer's markup is fetched by JavaScript
 * in the first place, so there is no JS-off reader to serve here.
 */
(() => {
  const TOGGLE = '[data-featured-toggle]';

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(TOGGLE);
    if (!toggle) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));

    /* The accessible name says what the control will DO next, not what it just
       did — a button reading "Show 3 more" while expanded is a lie. Both
       strings come from the markup so this file carries no copy. */
    const label = toggle.querySelector('[data-featured-toggle-label]');
    if (!label) return;
    const next = expanded ? label.dataset.more : label.dataset.less;
    if (next) label.textContent = next;
  });
})();
